module.exports = __webpack_public_path__ + "static/media/icoLink.7c8dfd4b.svg";